import React, { useState, useEffect } from 'react';
import './fundSelector.css';
import "../../common/css/protagonistForm.css";
import { useForm } from "react-hook-form";
import { GetAllFunds } from '../../common/api/FundAPIHelper';

function FundSelector({ onFundSelect, showLabel = false, enableAllFunds = false }) {
    const { register, watch, formState: { errors } } = useForm();
    const [fundOptions, setFundOptions] = useState([]);
    const selectedFund = watch("fund");

    useEffect(() => {
        const fetchFundOptions = async () => {
            const response = await GetAllFunds();

            if (response && response.body) {
                const funds = JSON.parse(response.body);
                setFundOptions(funds);
                if (funds[0]) {
                    onFundSelect(funds[0]);
                }
            }
        };

        fetchFundOptions();
    }, []);

    useEffect(() => {
        const userSelectedFundId = Number(selectedFund);
        const userSelectedFund = fundOptions.find(fund => fund.internal_fund_id === userSelectedFundId);
        
        // Pass null if 'All Funds' is selected
        onFundSelect(selectedFund === 'all' ? null : userSelectedFund);
    }, [selectedFund]);
    

    return (
        <form className="fund-selector-form">
            <div className="fund-selector-form-group">
                {showLabel && <label htmlFor="fund">Fund*</label>}
                <select {...register("fund", { required: true })}>
                    {fundOptions.map((fund, index) => (
                        <option
                            key={fund.internal_fund_id}
                            value={fund.internal_fund_id}
                            selected={index === 0}
                        >
                            {fund.fund_name}
                        </option>
                    ))}
                    {enableAllFunds && <option value="all">All Funds</option>}
                </select>
                {errors.fund && <span>This field is required</span>}
            </div>
        </form>
    );
}

export default FundSelector;
